export const ContractFilterOrder = [
  'JobTitle',
  'ManagerNames',
  'ManagerFlag',
  'ContractType',
  'StartDate',
  'EmployeesTenure',
  'RecruitmentReason',
  'TerminationCause',
  'Termination',
  'TerminationCauseVoluntary',
];

export const EmployeesFilterOrder = [
  'Gender',
  'Date_of_birth',
  'EmployeesAge',
  'MaritalStatus',
  'Nationality',
  'EmployeesCity',
  'EmployeesCountry',
];

export const OrganizationFilterOrder = [
  'CompanyName',
  'Entities',
  'Department',
  'CompanyCity',
  'CompanyCountry',
];

export const fileFormat = {
  CSV: 'CSV',
  EXCEL: 'Excel',
  PDF: 'PDF',
};

export const FileExtensionMapping = {
  Excel: 'xlsx',
  CSV: 'csv',
  default: 'csv',
};
export const trainingCostMetrics = ['TotalTrainingCost', 'TrainingSalaryCost', 'TrainingCost'];

export const oneDecimalSubMetric = new Set([]);

export const filtersToIgnoreSort = new Set(['EmployeesTenure']);

export const SUPER_ADMIN_DOMAIN = 'Super Admin Domain';

export const DashboardRoles = {
  Viewer: 'Viewer',
  Editor: 'Editor',
  Owner: 'Owner',
};

export const DASHBOARD_OPTIONS = [
  { id: 'existing', label: 'Existing dashboard', value: 'existing' },
  { id: 'new', label: 'New dashboard', value: 'new' },
];

export const filtersCategories = {
  Organization: 'Organization',
  Employees: 'Employees',
  Contract: 'Contract',
  Recruitment: 'Recruitment',
  Training: 'Training',
  Compensation: 'Compensation',
};

export const TableCharts = ['AdvancedTable', 'DataGrid', 'Table'];

export const NO_GROUPING = 'NoGrouping';
export const DEFAULT_PERIOD = 'Default period';
export const SORT_STORAGE_KEY = 'dashboard_sort_preferences';
export const RAPID_ACTIONS = {
  ANALYTICS: 'Start analytics',
  ORG_CHART: 'Explore your organization',
  PEOPLE: 'Access all employees',
  COMPLIANCE: 'Check compliance',
};
export const BDESEHeadcountBreakPoint = 300;
export const INDEX_MW = 'IndexMW';
export const CUSTOM_CHART = 'Custom chart';
export const XAXIS = {
  MONTHS: 'Months',
};

export const euroMetrics = [
  'AverageSalary',
  'GrossSalary',
  'TotalChargedSalary',
  'AverageNetSalary',
  'MedianNetSalary',
  'MedianSalary',
  'MaxNetSalary',
  'MaxSalary',
  'MinNetSalary',
  'MinSalary',
  'Q1NetSalary',
  'Q1Salary',
  'Q3NetSalary',
  'Q3Salary',
  'NetSalary',
  'AnnualChangeSalary',
  'GapGenderAbsoluteGrossSalary',
  'AverageCumulativeSalary',
  'AverageTrainingCostPerEmployee',
  'AverageTrainingSalaryCostPerEmployee',
  'AverageTotalTrainingCostPerEmployee',
  'AverageTrainingCostPerTrainee',
  'AverageTrainingSalaryCostPerTrainee',
  'AverageTotalTrainingCostPerTrainee',
  'AverageHourlyWage',
  'TrainingCost',
  'TrainingSalaryCost',
  'TotalTrainingCost',
  'GrossSalaryPerFTE',
  'ChargedSalaryPerFTE',
  'NetSalaryPerFTE',
];

export const percentageMetrics = [
  'TurnoverRate',
  'AttritionRate',
  'AttritionRateVoluntary',
  'TurnoverRateVoluntary',
  'AnnualChangeRateSalary',
  'GapGenderRateGrossSalary',
  'AbsenteeismRateTraining',
  'ManagerRatio',
  'AbsenteeismRate',
  'CancelSessionsRate',
  'RateOfTrainees',
  'FailedHiresRatio3Months',
  'FailedHiresRatio6Months',
  'FailedHiresRatio12Months',
  'FemaleRate',
  'RetentionRate',
  'Attrition Rate',
  'Turnover Rate',
  'Absenteeism Rate',
];

export const timeMetrics = ['Age average', 'AverageTenure', 'TimeToHire', 'TotalAbsenceDays'];
export const officialColorsName = 'officialColors';
